import type { MutationHookOptions } from '@apollo/client'
import { GetBookingsDataTableDocument } from 'generated/resources/datatable.graphql'
import 'generated/resources/graphql'
import {
  BulkCancelSpacecontrolBookingDocument,
  BulkCancelSpacecontrolBookingMutation,
  BulkCancelSpacecontrolBookingMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  BulkCancelSpacecontrolBookingMutation,
  BulkCancelSpacecontrolBookingMutationVariables
>

export const useBulkCancelBooking = (bookingIds: number[], options?: Options) => {
  const [CancelSpacecontrolBookingMutation, { loading }] = useMutation(
    BulkCancelSpacecontrolBookingDocument,
    {
      ...options,
      awaitRefetchQueries: true,
      extractorFn: (data: BulkCancelSpacecontrolBookingMutation) =>
        data.spaceControlMutations.bulkCancelSpacecontrolBooking,
    }
  )

  return {
    loading,
    cancelBooking() {
      return CancelSpacecontrolBookingMutation({
        variables: { ids: bookingIds },
        refetchQueries: [GetBookingsDataTableDocument],
      })
    },
  }
}
